/**
 *  @swagger
 *  definitions:
 *    CrewmemberPushTokenParams:
 *      type: object
 *      properties:
 *        CrewmemberId:
 *          description: ID of the associated Crewmember
 *          type: string
 *        Value:
 *          description: Value of the CrewmemberPushToken
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    CrewmemberPushTokenCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/CrewmemberPushTokenParams'
 *        - type: object
 *          required:
 *            - CrewmemberId
 *            - Value
 *
 *  @swagger
 *  definitions:
 *    CrewmemberPushTokenQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the CrewmemberPushToken
 *              type: string
 *        - $ref: '#/definitions/CrewmemberPushTokenParams'
 *
 *  @swagger
 *  definitions:
 *    CrewmemberPushTokenUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/CrewmemberPushTokenQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    CrewmemberPushToken:
 *      allOf:
 *        - $ref: '#/definitions/CrewmemberPushTokenCreateParams'
 *        - $ref: '#/definitions/CrewmemberPushTokenUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      CrewmemberPushToken:
 *        allOf:
 *          - $ref: '#/definitions/CrewmemberPushToken'
 *          - type: object
 *            properties:
 *              Crewmember:
 *                description: Crewmember of the CrewmemberPushToken
 *                $ref: '#/components/schemas/Crewmember'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  CrewmemberId: string;
};

export type $Params = {
  Value: string;
};

export type $CreateParams = $Params & $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Crewmember?: $Model<'Crewmember'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = $Params & {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
  Value: {
    allowNull: false,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'CrewmemberPushToken'> => {
  const CrewmemberPushToken = stack.define(
    'CrewmemberPushToken',
    fields(Sequelize),
    {
      tableName: 'CrewmemberPushTokens',
    },
  );

  CrewmemberPushToken.associate = (models: $ModelClasses) => {
    models.CrewmemberPushToken.belongsTo(
      models.Crewmember,
      {
        as: 'Crewmember',
        foreignKey: 'CrewmemberId',
      },
    );
  };

  CrewmemberPushToken.addScope(
    'defaultScope',
    {
      order: [['createdAt', 'ASC']],
    },
  );

  return CrewmemberPushToken;
});
